import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { ErrorState } from './page-state.js';
/**
 * The last net under an app: an error nothing else caught - in a frame, a banner, a library -
 * shows a page to try again or start over instead of an empty window. A route's own errors are
 * caught nearer (`defaultErrorComponent`); this one is for the rest. Nothing is logged here: the
 * browser shows the error, and no personal data leaves it.
 */
export class AppErrorBoundary extends Component {
    state = { error: null };
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        if (this.state.error === null)
            return this.props.children;
        return (_jsx(ErrorState, { error: this.state.error, onRetry: () => this.setState({ error: null }), onHome: () => window.location.assign('/') }));
    }
}
//# sourceMappingURL=app-error-boundary.js.map